var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 122 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32.297 12.827-21.832 15.45a13.058 13.058 0 0 1-1.978-6.96C8.487 13.96 14.501 8 21.935 8a13.435 13.435 0 0 1 10.362 4.827Z",
    fill: "url(#logo_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.563 24.137a13.089 13.089 0 0 0-1.978-6.961l-10.891 7.7L8.75 32.61l-.579.413L8.198 48s14.395-9.624 18.933-13.158c3.374-2.636 5.431-6.327 5.431-10.705Z",
    fill: "url(#logo_svg__c)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__d)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.995 18.144h3.852l.095 1.706h.055a3.93 3.93 0 0 1 1.768-1.426 6.5 6.5 0 0 1 2.758-.567c1.984 0 3.586.657 4.806 1.973 1.22 1.316 1.831 3.08 1.832 5.293v.442c0 2.21-.598 3.972-1.796 5.286-1.198 1.314-2.77 1.977-4.718 1.989a7.31 7.31 0 0 1-2.725-.48 3.935 3.935 0 0 1-1.81-1.31v7.198h-4.117V18.144Zm5.368 10.968c.642.416 1.394.63 2.159.614 1.156 0 2.017-.348 2.58-1.045.565-.697.847-1.66.847-2.889v-.884c0-1.228-.28-2.193-.84-2.895-.56-.7-1.431-1.052-2.616-1.052a3.702 3.702 0 0 0-3.414 2.023v4.67c.272.603.72 1.11 1.284 1.458ZM61.928 18.144h3.907l.082 1.788H66a4.049 4.049 0 0 1 1.399-1.547 3.554 3.554 0 0 1 2.015-.615c.205.001.409.024.608.069.15.027.299.068.442.121v3.496a7.498 7.498 0 0 0-.546-.088 5.686 5.686 0 0 0-.643-.033 3.417 3.417 0 0 0-1.954.588c-.555.36-.995.871-1.268 1.474v9.151h-4.124V18.144ZM71.557 25.123c0-2.268.737-4.068 2.21-5.401 1.473-1.334 3.389-2.001 5.746-2.003 2.366 0 4.281.668 5.746 2.003 1.464 1.334 2.197 3.135 2.199 5.4v.443c0 2.267-.733 4.067-2.2 5.4-1.465 1.334-3.38 2.002-5.745 2.003-2.357 0-4.273-.667-5.746-2.002-1.473-1.335-2.21-3.135-2.21-5.401v-.442Zm4.199.663c0 1.311.328 2.315.984 3.012.655.697 1.574 1.045 2.758 1.043 1.178 0 2.096-.348 2.753-1.043s.983-1.7.977-3.012v-.902c0-1.31-.329-2.314-.986-3.012s-1.569-1.044-2.736-1.037c-1.178 0-2.096.349-2.751 1.046-.656.697-.986 1.7-.99 3.012l-.009.893ZM90.216 18.144h3.905l.082 1.803h.068a4.818 4.818 0 0 1 1.958-1.565 6.225 6.225 0 0 1 2.555-.526 5.746 5.746 0 0 1 2.813.663 3.976 3.976 0 0 1 1.768 1.945h.042a5.137 5.137 0 0 1 2.225-1.951 6.925 6.925 0 0 1 2.964-.663c1.568 0 2.831.478 3.79 1.434.959.956 1.439 2.55 1.441 4.78v8.484h-4.117v-8.723c-.009-.965-.223-1.675-.641-2.13-.419-.455-1.042-.683-1.872-.683a3.068 3.068 0 0 0-1.859.546c-.545.394-.981.92-1.268 1.53v9.46h-4.117v-8.683c-.009-.984-.225-1.705-.648-2.163-.424-.46-1.058-.69-1.907-.69a3.13 3.13 0 0 0-1.83.54 3.742 3.742 0 0 0-1.242 1.535v9.461h-4.11V18.144Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__b",
    x1: 25.59,
    y1: 8.533,
    x2: 11.805,
    y2: 24.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE448A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__c",
    x1: 30.355,
    y1: 23.881,
    x2: 9.694,
    y2: 40.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE448A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8.171 8)",
    d: "M0 0h31.823v40H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(43.995 8)",
    d: "M0 0h69.834v40H0z"
  })))));
};
export default SvgLogo;